// src/components/QueimogramaModal.js
import React, { useState } from 'react';
import { Modal } from './Modal';
import { Button } from './Button';

// Perguntas adaptadas para avaliação do Oficial pelo Cadete
const questions = [
    { label: 'O Oficial demonstrou domínio técnico-profissional?', name: 'conhecimento_tecnico' },
    { label: 'O Oficial foi pontual e cumpriu os horários previstos?', name: 'pontualidade' },
    { label: 'A postura e apresentação pessoal do Oficial foram exemplares?', name: 'apresentacao_pessoal' },
    { label: 'Houve respeito e urbanidade no trato com a tropa e com o aluno?', name: 'interacao_tropa' },
    { label: 'O Oficial demonstrou interesse em instruir e orientar o aluno?', name: 'dedicacao_ensino' },
    { label: 'Houve equilíbrio emocional durante as ocorrências?', name: 'estabilidade_emocional' },
    { label: 'O Oficial demonstrou capacidade de decisão adequada?', name: 'capacidade_decisao' },
    { label: 'O Oficial agiu com ética e compromisso institucional?', name: 'etica_compromisso' },
    { label: 'O Oficial demonstrou liderança durante o serviço?', name: 'lideranca' },
    { label: 'De 0 a 10, qual nota geral você daria para o estágio com este Oficial?', name: 'nota_geral' },
];

export const QueimogramaModal = ({ show, onClose, escolha, onConfirm, processing }) => {
    const [formData, setFormData] = useState({});

    const handleChange = (name, value) => {
        // Se for o campo de texto (informações complementares), salva como string
        // Se for as perguntas de avaliação (radio buttons), converte para inteiro
        const finalValue = name === 'informacoes_complementares' ? value : parseInt(value);
        setFormData(prev => ({ ...prev, [name]: finalValue }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onConfirm(formData);
    };

    return (
        <Modal show={show} onClose={onClose} title="Queimograma (Avaliação do Preceptor)" size="lg">
            <form onSubmit={handleSubmit} className="space-y-6">
                
                {/* Aviso de Confidencialidade */}
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded text-sm text-yellow-800">
                    <p className="font-bold text-lg mb-2">🔒 CONFIDENCIAL</p>
                    <p className="mb-2">
                        Esta avaliação é <strong>anônima e confidencial</strong> para fins estatísticos.
                        Sua identidade não será revelada ao Oficial avaliado.
                    </p>
                    <p>
                        O objetivo é fornecer dados ao Corpo de Oficiais da Academia para analisar a aptidão dos preceptores 
                        e subsidiar estudos para o futuro corpo docente da APMBB. 
                        <strong>Seja honesto, justo e profissional em suas respostas.</strong>
                    </p>
                </div>

                <div className="bg-gray-50 p-4 rounded border">
                    <p className="font-bold text-gray-700">Oficial Avaliado:</p>
                    <p className="text-gray-900 text-lg">{escolha?.preceptor_nome || "Oficial Preceptor do Estágio"}</p>
                    <p className="text-sm text-gray-500">{escolha?.local_nome} - {escolha?.data ? new Date(escolha.data.toDate()).toLocaleDateString('pt-BR') : ''}</p>
                </div>

                <div className="space-y-4">
                    <h4 className="font-bold text-gray-800 border-b pb-2">Avaliação de Quesitos (Escala 0 a 10)</h4>
                    
                    {questions.map((q, idx) => (
                        <div key={idx} className="bg-white p-3 rounded shadow-sm border border-gray-100">
                            <label className="block text-sm font-medium text-gray-700 mb-2">{idx + 1}. {q.label}</label>
                            <div className="flex justify-between items-center gap-1">
                                <span className="text-xs text-red-500 font-bold">0</span>
                                {[...Array(11)].map((_, i) => (
                                    <label key={i} className="flex flex-col items-center cursor-pointer">
                                        <input 
                                            type="radio" 
                                            name={q.name} 
                                            value={i} 
                                            required 
                                            onChange={(e) => handleChange(q.name, e.target.value)}
                                            className="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300"
                                        />
                                        <span className="text-[10px] text-gray-500 mt-1">{i}</span>
                                    </label>
                                ))}
                                <span className="text-xs text-green-500 font-bold">10</span>
                            </div>
                        </div>
                    ))}

                    {/* --- CAMPO NOVO: INFORMAÇÕES COMPLEMENTARES --- */}
                    <div className="bg-white p-3 rounded shadow-sm border border-gray-100 mt-4">
                        <label className="block text-sm font-bold text-gray-800 mb-2">Informações Complementares (Opcional)</label>
                        <p className="text-xs text-gray-500 mb-2">Utilize este espaço para detalhar situações específicas, elogios ou críticas construtivas.</p>
                        <textarea
                            name="informacoes_complementares"
                            rows="4"
                            className="w-full border p-2 rounded text-sm focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Descreva aqui..."
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                        ></textarea>
                    </div>
                </div>

                <div className="pt-4 border-t flex justify-end gap-3">
                    <Button variant="secondary" onClick={onClose} disabled={processing}>Cancelar</Button>
                    <Button type="submit" variant="primary" disabled={processing}>
                        {processing ? "Enviando..." : "Enviar Avaliação Confidencial"}
                    </Button>
                </div>
            </form>
        </Modal>
    );
};